import { Box, TableCell, styled } from "@mui/material"
import { Check, RefreshCw } from "react-feather"
import type { OperationStateEnum } from "../../AdherentMarketingOperations"
import {
  DangerCircle,
  SuccessCircle,
} from "../../AdherentMarketingOperations/AdhMarketingOPList/icons"

interface JustificationCellProps {
  state: OperationStateEnum
}

const JustificationLabel = styled("span")(({ theme }) => ({
  color: "inherit",
  fontSize: theme.typography.pxToRem(12),
}))

const Justification = ({ state }: JustificationCellProps) => {
  switch (state) {
    case "REJECTED":
      return (
        <Box display="flex" alignItems="center" gap={0.5} color="error.main">
          <DangerCircle />
          <JustificationLabel>Justificatifs refusés</JustificationLabel>
        </Box>
      )
    case "REVIEWED":
      return (
        <Box display="flex" alignItems="center" gap={0.5} color="success.main">
          <SuccessCircle variant="outlined" icon={<RefreshCw />} />
          <JustificationLabel>Justificatifs transmis</JustificationLabel>
        </Box>
      )
    case "VALIDATED":
      return (
        <Box display="flex" alignItems="center" gap={0.5} color="success.main">
          <SuccessCircle variant="outlined" icon={<Check />} />
          <JustificationLabel>Justificatifs validés</JustificationLabel>
        </Box>
      )
    default:
      return null
  }
}

export const AdhJustificationCell = (props: JustificationCellProps) => {
  return (
    <TableCell>
      <Justification {...props} />
    </TableCell>
  )
}
